import { Typography, Box } from '@mui/material';
import type { FC } from 'react';
import { Controller, useWatch } from 'react-hook-form';
import { RadioGroup } from '../../../../components/RadioGroup';
import { ConfigurationSection } from '../../../../containers/ConfigurationSection';
import type {
  QuickBooksConfigurationControl,
  QuickBooksConfigurationFormValues,
} from '../../QuickBooksConfigurationFormSchema';
import { TAX_EXPORT_STRATEGY } from '@vy/integrations-types';
import { TAX_EXPORT_STRATEGY_OPTIONS } from './constants';
import { ControlledQuickBooksProductDropdown } from './ControlledQuickBooksProductDropdown';

type TaxConfigurationSectionProps = {
  control: QuickBooksConfigurationControl;
  defaultValues: QuickBooksConfigurationFormValues;
};

export const TaxConfigurationSection: FC<TaxConfigurationSectionProps> = ({
  control,
  defaultValues,
}) => {
  const taxExportStrategy = useWatch({ control, name: 'taxExportStrategy' });
  const isSeparateLineItem = taxExportStrategy === TAX_EXPORT_STRATEGY.SEPARATE_LINE_ITEM;

  return (
    <ConfigurationSection title="Tax" iconName="InvoiceListItem">
      <Controller
        name="taxExportStrategy"
        control={control}
        defaultValue={defaultValues.taxExportStrategy}
        render={({ field: { value, onChange } }) => (
          <RadioGroup
            title="Choose how tax is exported"
            value={value}
            onChange={onChange}
            keyExtractor={(option) => option.value}
            options={TAX_EXPORT_STRATEGY_OPTIONS}
          />
        )}
      />
      {isSeparateLineItem && (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          <Typography variant="subtitle2">
            Select a QuickBooks product for tax
          </Typography>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            <Typography
              sx={{
                fontSize: '12px',
                fontWeight: 400,
                lineHeight: '12px',
              }}
            >
              Account
            </Typography>
            <ControlledQuickBooksProductDropdown
              control={control}
              fieldPath="accountTaxItem"
              showDropdown={true}
              placeholder="Select QuickBooks tax item"
            />
          </Box>
        </Box>
      )}
    </ConfigurationSection>
  );
};
